import { Link } from "react-router-dom";
import { ReactComponent as IconExclamation } from "assets/images/icons/project-icons/exclamation.svg"
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";


const OnboardingComplianceIndex = () => {
    return (
        <>
        
            <DynamicHeadTag
                headerText="BVN & CAC Compliance"
            />
            
            <div className="w-screen max-w-sm absolute z-20 top-1/2 right-1/2 bg-white h-max rounded-xl shadow-xl transform translate-x-1/2 -translate-y-1/2">
                <div className="w-screen max-w-sm h-full flex flex-col space-y-6 relative overflow-y-scroll">
                    <div className="p-8 text-center">
                
                        <div className="flex">
                            <IconExclamation className="m-auto" />
                        </div>
                        
                        <div className="mt-4 font-medium text-lg">
                            Complete your registration
                        </div>

                        <div className="mt-4 text-[#667085]">
                            Your BVN is crucial for identification and banking purposes, while the CAC status report will help us ensure alignment with official records, Kindly submit both to complete your registration.
                        </div>

                        <div className="mt-8 flex space-x-3 justify-start">
                            <Link to="/get-started/compliance/bvn" type="button" className="btn btn-block btn-ep-primary btn-lg">
                                Complete Registration
                            </Link>
                        </div>
                        
                    </div>
                </div>
            </div>
            
            <div className="fixed overflow-auto z-10 bg-[#111111] bg-opacity-40 inset-0 transform opacity-40 translate-y-0"></div>
        </>
    )
}


export default OnboardingComplianceIndex;